import { createFileRoute } from "@tanstack/react-router";
import { routeMeta } from "@/lib/route-meta";
import Admin from "@/pages/Admin";

export const Route = createFileRoute("/admin")({ head: () => routeMeta('Admin Portal | MNRE', 'Manage MNRE properties, leads, contacts, appointments and operations.', '/admin'), component: Admin });
